let VERSION = 'unknown version';

if (process.env.REACT_APP_VERSION) {
  VERSION = `${process.env.REACT_APP_VERSION}${ process.env.NODE_ENV === 'development' ? '-dev' : '' }`;
}

export default VERSION;
